import { css } from "@emotion/react";

export const GlobalStyles = css`
  @font-face {
    font-family: "DIN";
    src: url("/fonts/DIN-Regular.otf") format("opentype");
    font-style: normal;
    font-weight: 400;
  }
  @font-face {
    font-family: "DIN";
    src: url("/fonts/DIN-Medium.otf") format("opentype");
    font-style: normal;
    font-weight: 500;
  }
  @font-face {
    font-family: "DIN";
    src: url("/fonts/DIN-Bold.otf") format("opentype");
    font-style: normal;
    font-weight: 700;
  }

  @font-face {
    font-family: "DIN";
    src: url("/fonts/DIN-MediumItalicAlt.otf") format("opentype");
    font-style: italic;
    font-weight: 500;
  }

  @font-face {
    font-family: "DIN";
    src: url("/DIN-BoldItalic.otf") format("opentype");
    font-style: italic;
    font-weight: bold;
  }

  @font-face {
    font-family: "DIN-Black";
    src: url("/fonts/DIN-Black.otf") format("opentype");
    font-style: normal;
    font-weight: 900;
  }

  @font-face {
    font-family: "DIN-MediumItalic";
    src: url("/fonts/DIN-MediumItalic.otf") format("opentype");
    font-style: italic;
    font-weight: 500;
  }
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    line-height: 1;
    font-family: "DIN";
    font-weight: 500;
    font-style: normal;
  }

  html {
    height: 100%;
  }
  body {
    margin: 0;
    height: 100%;
  }
  #root {
    height: 100%;
  }

  /* 隐藏所有滚动条 */
  ::-webkit-scrollbar {
    display: none;
  }

  * {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
